"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TooltipAnchor = require("./tooltip/TooltipAnchor");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextTooltipWrapper = _styledComponents.default.span.withConfig({
  displayName: "Badge__TextTooltipWrapper",
  componentId: "j4izdp-0"
})(["line-height:1.5;text-align:center;white-space:pre-line;"]);

var TextTooltip = function TextTooltip(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react.default.createElement(TextTooltipWrapper, null, text);
};

TextTooltip.propTypes = {
  text: _propTypes.default.string.isRequired
};
var BADGE_COLOR = {
  error: '#DD2C00',
  info: '#424242',
  success: '#2E7D32',
  warning: 'orange'
};

var BadgeWrapper = _styledComponents.default.span.withConfig({
  displayName: "Badge__BadgeWrapper",
  componentId: "j4izdp-1"
})(["position:relative;top:-0.1em;display:inline-block;padding:0.25em 0.4em 0.2em;border:1px solid #000;border-radius:0.3em;background:", ";color:", ";font-size:0.75em;font-weight:bold;line-height:1;"], function (props) {
  return BADGE_COLOR[props.level];
}, function (props) {
  return props.level === 'warning' ? '#000' : '#fff';
});

var Badge = function Badge(_ref2) {
  var children = _ref2.children,
      level = _ref2.level,
      tooltip = _ref2.tooltip;
  return tooltip ? /*#__PURE__*/_react.default.createElement(_TooltipAnchor.TooltipAnchor, {
    text: tooltip,
    tooltipComponent: TextTooltip
  }, /*#__PURE__*/_react.default.createElement(BadgeWrapper, {
    level: level
  }, children)) : /*#__PURE__*/_react.default.createElement(BadgeWrapper, {
    level: level
  }, children);
};

exports.Badge = Badge;
Badge.propTypes = {
  children: _propTypes.default.string.isRequired,
  level: _propTypes.default.oneOf(['error', 'info', 'success', 'warning']),
  tooltip: _propTypes.default.string
};
Badge.defaultProps = {
  level: 'info',
  tooltip: undefined
};